<template>
  <div>
    <v-navigation-drawer
      v-if="isUser"
      v-model="drawer"
      fixed
      app
    >
      <v-layout
        justify-space-between
        column
        fill-height
      >
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-img
                class="adminLogo"
                :src="scoutAdminImage"
              />
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="{path: item.link}"
            :disabled="item.disabled"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-btn
          id="logout-button"
          exact
          align-end
          justify-end
          color="error"
          :loading="loggingOut"
          :disabled="loggingOut"
          @click="logout(); loader = 'loggingOut'"
        >
          Logout
          <template v-slot:loader>
            <span>Logging out...</span>
          </template>
        </v-btn>
      </v-layout>
    </v-navigation-drawer>

    <v-app-bar
      color="blue"
      dark
      fixed
      app
    >
      <v-app-bar-nav-icon
        v-if="isUser"
        @click.stop="drawer = !drawer"
      />
      <v-toolbar-title v-if="isUser">
        SCOUT Admin Panel
      </v-toolbar-title>
      <v-toolbar-title v-else>
        Message Room
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>

    <v-footer
      color="blue"
      app
      inset
    >
      <span class="white--text">&copy; 2020</span>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "AdminMainContainer",
  data() {
    return {
      items: [
        { title: "Dashboard", icon: "mdi-view-dashboard", link: "/admin/dashboard/" },
        { title: "Conversations", icon: "chat", link: "/admin/conversations/" },
        { title: "Surveys", icon: "mdi-file-multiple", link: "/admin/surveys" },
        { title: "Settings", icon: "mdi-settings", link: "/", disabled: true }
      ],
      drawer: null,
      isUser: localStorage.getItem("TOKEN_STORAGE_KEY"),
      loader: null,
      loggingOut: false,
      scoutAdminImage: require('../../public/static/M-CORES/AdminPanelNav.png')
    };
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 1500)

      this.loader = null
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      setTimeout(() => {
        this.$router.go({name: 'login', path: "/login"})
      }, 1500)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
v-navigation-drawer {
  overflow: hidden;
}
v-footer {
  bottom: 0;
  width: 100%;
}
.v-content {
  padding-top: 80px !important
}
</style>

<style>
.adminLogo {
  padding-left: 0;
  margin-left: -2%;
  margin-top: -5%;
  margin-bottom: -12%;
}
</style>